import { Close, Save } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  IconButton,
  MenuItem,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../../theme/theme";

export const EditCustomerDialog = ({
  openEditDialog,
  setOpenEditDialog,
  fetchingCustomer,
  selectedCustomer,
  setSelectedCustomer,
  updateCustomer,
  errors,
  updatingCustomer,
}) => {
  return (
    <Dialog
      open={openEditDialog}
      onClose={() => setOpenEditDialog(false)}
      PaperProps={{
        sx: {
          borderRadius: theme.dialog.borderRadius,
          minWidth: theme.dialog.minWidth,
          maxWidth: "600px",
          width: "100%",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            fontWeight={"bold"}
            color={theme.palette.primary.main}
          >
            Edit Customer
          </Typography>
        </Box>
        <Box>
          <IconButton onClick={() => setOpenEditDialog(false)}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ p: 4, maxHeight: "70vh", overflowY: "auto" }}>
        {fetchingCustomer ? (
          <>
            <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
            <Skeleton variant="rounded" height={56} sx={{ mb: 2 }} />
          </>
        ) : (
          <>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Customer Details
            </Typography>
            <TextField
              label="Name"
              fullWidth
              value={selectedCustomer.name || ""}
              onChange={(e) =>
                setSelectedCustomer({
                  ...selectedCustomer,
                  name: e.target.value,
                })
              }
              error={!!errors.name}
              helperText={errors.name}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Email"
              fullWidth
              value={selectedCustomer.email || ""}
              onChange={(e) =>
                setSelectedCustomer({
                  ...selectedCustomer,
                  email: e.target.value,
                })
              }
              error={!!errors.email}
              helperText={errors.email}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Phone"
              fullWidth
              value={selectedCustomer.phone || ""}
              onChange={(e) =>
                setSelectedCustomer({
                  ...selectedCustomer,
                  phone: e.target.value,
                })
              }
              error={!!errors.phone}
              helperText={errors.phone}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Address"
              fullWidth
              multiline
              rows={3}
              value={selectedCustomer.address || ""}
              onChange={(e) =>
                setSelectedCustomer({
                  ...selectedCustomer,
                  address: e.target.value,
                })
              }
              error={!!errors.address}
              helperText={errors.address}
              sx={{ mb: 3 }}
            />

            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              Account Settings
            </Typography>
            <TextField
              label="Account Status"
              fullWidth
              select
              value={
                selectedCustomer.is_active !== undefined
                  ? selectedCustomer.is_active
                    ? "1"
                    : "0"
                  : "1"
              }
              onChange={(e) =>
                setSelectedCustomer({
                  ...selectedCustomer,
                  is_active: e.target.value === "1",
                })
              }
              error={!!errors.is_active}
              helperText={errors.is_active}
              sx={{ mb: 2 }}
            >
              <MenuItem value="1">Active</MenuItem>
              <MenuItem value="0">Inactive</MenuItem>
            </TextField>
          </>
        )}
      </Box>
      <Box
        sx={{
          backgroundColor: theme.dialog.headerBgColor,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={() => setOpenEditDialog(false)}
          sx={{
            backgroundColor: theme.button.backgroundColor,
            color: "#000",
            borderRadius: theme.button.borderRadius,
          }}
        >
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => updateCustomer()}
          sx={{
            backgroundColor: theme.button.editBackgroundColor,
            borderRadius: theme.button.borderRadius,
          }}
          disabled={updatingCustomer}
          startIcon={<Save />}
        >
          {updatingCustomer ? "Updating..." : "Update Customer"}
        </Button>
      </Box>
    </Dialog>
  );
};
